module.exports = __webpack_public_path__ + "media/images/emblems/Lajoux-a0eee7220992664f70e2af998967dbe5.png";